<template>
  <div>
    <CRow>
      <CCol sm="12" class="p-0">
        <CCard>
          <div
            class="px-3 d-flex flex-wrap w-100 border-bottom align-items-center"
          >
            <h5 class="flex-grow-1 col-xs-6 my-2">Administrativos</h5>
            <DateSelector
              initDates="week"
              :date="initDates"
              v-model="initDates"
              class="margi-dates z-custom-2 col-xs-6 my-2"
            />
            <div class="d-flex flex-wrap col-xs-12 my-2">
              <v-select
                class="selector-input"
                :options="cultivos"
                v-model="cropGraphs"
                :loading="isLoadingPage"
                placeholder="Cultivo"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
              <v-select
                class="selector-input"
                :options="variedadesPorCultivo"
                v-model="variedadGraphs"
                :loading="isLoadingPage"
                placeholder="Variedad"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
              <v-select
                class="selector-input"
                :options="embalajesPorCultivo"
                v-model="embalajeGraphs"
                :loading="isLoadingPage"
                :multiple="true"
                placeholder="Embalaje"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
              <v-select
                class="selector-input"
                :options="ubicaciones2"
                v-model="locationGraphs"
                :loading="isLoadingPage"
                placeholder="Ubicacion"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
            </div>
          </div>
          <CCardBody class="p-0 pt-2">
            <CNav justified variant="tabs">
              <CNavItem :to="{
            name: 'Ingresos'
          }">Ingresos</CNavItem>
              <CNavItem
                :to="{
            name: 'IngresosAcumulados'
          }"
              >Ingresos Acumulados</CNavItem>
              <CNavItem :to="{
            name: 'Egresos'
          }">Egresos</CNavItem>
              <CNavItem :to="{
            name: 'EgresosAcumulados'
          }">Egresos Acumulados</CNavItem>
              <CNavItem
                :to="{
            name: 'IndicadoresAdmin'
          }"
                active
              >KPI's Administrativos</CNavItem>
              <CNavItem :to="{
            name: 'Comparativa'
          }">Comparativa</CNavItem>
            </CNav>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text">KPI's</CCardHeader>

          <CCardBody>
            <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoadingPage"
            >
              <div class="sk-flow d-flex align-items-center">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
            <CCardGroup v-else class="mb-4">
              <CWidgetProgressIcon
                :header="
                  entregas
                    ? `$${String(Math.floor(entregas.total*100)/100)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                    : `$0`
                "
                text="Ingresos totales"
                color="primary"
                inverse
              >
                <template #progress>
                  <div></div>
                </template>
                <CIcon class="txt-green" name="cil-dollar" height="48" />
              </CWidgetProgressIcon>

              <CWidgetProgressIcon
                :header="
                  costos
                    ? `$${costos.total
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                    : `$0`
                "
                text="Costo total"
                color="warning"
                inverse
              >
                <template #progress>
                  <div></div>
                </template>
                <CIcon class="txt-red" name="cil-dollar" height="48" />
              </CWidgetProgressIcon>


            </CCardGroup>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text">Ingresos</CCardHeader>
          <CCardBody>
            <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoadingPage"
            >
              <div class="sk-flow d-flex align-items-center">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
            <CDataTable
              v-else
              hover
              small
              :items="itemsIngresos"
              :fields="fieldsIngresos"
              :noItemsView="noItems"
              pagination
            >
              <template #cultivo="{item}">
                <td class="py-2">
                  {{ `${item.cultivo} ${item.variedad}` }}
                </td>
              </template>
              <template #total="{item}">
                <td class="py-2">
                  {{
                  $formatter(item.total,true)
                  }}
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text">
            Egresos
            <span class="float-right">Total: {{ $formatter(_itemsCostos
              .filter(ff=>ff.ruta.split('/').length===1)
              .reduce((v,c)=>v+c.getTotal(),0),true)
            }}</span>
          </CCardHeader>
          <CCardBody>
            <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoadingPage"
            >
              <div class="sk-flow d-flex align-items-center">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
            <CDataTable
              v-else
              hover
              small
              :items="_itemsCostos"
              :fields="fieldsCostos"
              :noItemsView="noItems"
            >
              <template #concepto="{item}">
                  <td class="py-2" :style="`padding-left: ${(item.ruta?(item.ruta.split('/').length-1):0)}rem`">
                    <i :class="`fa fa-${item.children?`chevron-${collapses.includes(item.ruta)?'down':'right'}`:'minus'}`" @click="()=>item.children?toggleCollapse(item.ruta):null" />
                    {{item.concepto.toCapitalize()}}
                  </td>
              </template>
              <template #total="{item}">
                <td class="py-2">
                  {{
                  $formatter(item.getTotal(),true)
                  }}
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import DateSelector from "../../../customComponents/DateSelector";
import moment from "moment";
import axios from "axios";

const fieldsIngresos = [
  { key: "cultivo", label: "Producto", _style: "width:20%" },
  { key: "embalaje", label: "Embalaje", _style: "width:20%" },
  { key: "cantidad", label: "Cantidad", _style: "width:20%" },
  { key: "total", label: "Total", _style: "width:20%" },
  {
    key: "cantidad_sin_precio",
    label: "Cantidad sin precio",
    _style: "width:20%"
  }
];

const fieldsProduccion = [
  { key: "cultivo", label: "Producto", _style: "width:33%" },
  { key: "embalaje", label: "Embalaje", _style: "width:33%" },
  { key: "cantidad", label: "Cantidad", _style: "width:33%" }
];

const fieldsCostos = [
  { key: "concepto", label: "Concepto", _style: "width:33%" },
  // { key: "categoria_raiz", label: "Categoria", _style: "width:33%" },
  { key: "total", label: "Total", _style: "width:33%" }
];

const fieldsKPI = [
  { key: "nombre", label: "Etapa", _style: "width:16%" },
  { key: "pre_util", label: "Presupuesto utilizado", _style: "width:16%" },
  { key: "presupuesto", label: "Presupuesto", _style: "width:16%" },
  { key: "porcentaje", label: "%", _style: "width:16%" },
  { key: "fecha_inicial", label: "Fecha inicio", _style: "width:18%" },
  { key: "fecha_final", label: "Fecha fin", _style: "width:18%" }
];

export default {
  name: "IndicadoresAdmin",
  components: {
    vSelect,
    DateSelector
  },

  data() {
    return {
      collapses:[],
      options: ["hola", "adios"],
      cultivosAll: [],
      cultivos: [],
      cultivo: null,
      variedades: [],
      variedadGraphs: null,
      embalajes: [],
      embalajeGraphs: [],
      ubicaciones2: [],
      ubicacion2: null,
      lote: null,
      lotes: [],
      lotesAll: [],
      loteSelect: null,
      itemsIngresos: [],
      fieldsIngresos,
      itemsProduccion: [],
      fieldsProduccion,
      itemsCostos: [],
      fieldsCostos,
      itemsKPI: [],
      fieldsKPI,
      counter: 85,
      lotesPresupuesto: null,
      produccionEq: null,
      entregas: null,
      entregasEq: null,
      costos: null,
      costos_lotes: null,
      isLoadingPage: false,
      isLoteActive: true,
      costos_dia: [],
      dayValues: [],
      labels: [],
      color1: "primary",
      color2: "secondary",
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      data: [],
      dataBar: [],
      cancelSource: null,
      // date selector
      isCustomOpen: false,
      dates: {},
      selectedDate: {
        // start: new Date(today.getFullYear(), today.getMonth(), 1),
        // start: new Date(2019, 1, 1),
        // end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
        // end: new Date(2020, 2, 11)
      }
    };
  },

  created() {
    this.fetchCombos();
    this.updateAllInfo();
  },

  computed: {
    _itemsCostos(){
      const getTotal = function(){
        return this.children?this.children.reduce((v,c)=>{
          return v+c.getTotal()
        },0):(this.total||0)
      }

      const reduceCollapses = (v,c)=>{
        v.push(c)
        if(this.collapses.includes(c.ruta)){
          v.push(...c.children.reduce(reduceCollapses,[]))
        }
        return v
      }
      return [...this.itemsCostos].sort((a,b)=>a.concepto_ruta_nombre.localeCompare(b.concepto_ruta_nombre))
      .reduce((v,c)=>{
        const rutas = c.concepto_ruta_nombre.slice(1,-1).split('/')
        let pointer = v
        let ruta_ = ''
        rutas.forEach(ruta => {
          ruta_+=`${ruta_?'/':''}${ruta}`
          let found = pointer.find(f=>f.concepto === ruta )
          if(!found){
            let index = pointer.push({
              ruta:ruta_,
              concepto: ruta,
              getTotal,
              children: []
            })
            found = pointer[index-1]
          }
          pointer = found.children
        });
        pointer.push({...c,getTotal,ruta:`${ruta_}/${c.concepto}`})
        return v
      },[])
      .reduce(reduceCollapses,[])

    },
    clave_empresa() {
      return this.$store.state.clave_empresa.toUpperCase();
    },
    costoCaja() {
      if (this.costos && this.produccionEq) {
        if (this.costos.total > 0 && this.produccionEq.cantidad_eq > 0) {
          return String(
            (this.costos.total / this.produccionEq.cantidad_eq).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    roi() {
      if (this.costos && this.entregas) {
        if (this.costos.total > 0 && this.entregas.total > 0) {
          return String(
            ((this.entregas.total / this.costos.total) * 100).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    productividadVsObjetivo() {
      if (this.lote && this.loteSelect && this.produccionEq) {
        if (
          this.produccionEq.cantidad_eq > 0 &&
          this.loteSelect.payload.produccion_objetivo > 0
        ) {
          return String(
            (
              (this.produccionEq.cantidad_eq /
                this.loteSelect.payload.produccion_objetivo) *
              100
            ).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    ingresosVsObjetivo() {
      if (this.lote && this.loteSelect && this.entregas) {
        if (
          this.entregas.total > 0 &&
          this.loteSelect.payload.produccion_objetivo > 0
        ) {
          return String(
            (
              (this.entregas.total /
                this.loteSelect.payload.ingresos_objetivo) *
              100
            ).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    presupuestoUtilizado() {
      if (this.lote && this.loteSelect && this.costos) {
        let presupuestoLote = 0;
        this.loteSelect.payload.etapas.length > 0
          ? (presupuestoLote = this.loteSelect.payload.etapas.reduce(
              (acum, etapa) => acum + etapa.presupuesto,
              0
            ))
          : (presupuestoLote = 0);

        if (this.costos.total > 0 && presupuestoLote > 0) {
          return String(
            ((this.costos.total / presupuestoLote) * 100).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    initDates:{
      get() {
        return {
          start: moment(this.datesGraph[0]),

          end: moment(this.datesGraph[1])
        };
      },
      set(value) {
        const datesValues = [
          moment(value.start).format("YYYY-MM-DD"),
          moment(value.end).format("YYYY-MM-DD")
        ];
        this.$store.dispatch("setDateGraph", datesValues);
      }
    },
    datesGraph() {
      return this.$store.state.dateGraphs;
    },
    cropGraphs: {
      get() {
        return this.$store.state.cropGraphs;
      },
      set(value) {
        this.$store.dispatch("setCropGraph", value);
      }
    },
    locationGraphs: {
      get() {
        return this.$store.state.locationGraphs || this.$store.state.rootLocation;
      },
      set(value) {
        this.$store.dispatch("setLocationGraph", value);
      }
    },
    variedadesPorCultivo() {
      const cultivo = this.cropGraphs
      return cultivo === null ? [] : this.variedades.filter(variedad => {
        return cultivo.label === variedad.cultivo
      });
    },
    embalajesPorCultivo() {
      return this.cropGraphs ? this.cropGraphs.embalajes : []
    },
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateAllInfo();
      this.fetchCombos();
    },
    cropGraphs: function() {
      this.updateAllInfo();
      this.variedadGraphs = null
      this.embalajeGraphs = []
    },
    variedadGraphs: function() {
      if (!this.isLoadingPage) {
        this.updateAllInfo();
      }
    },
    embalajeGraphs: {
      deep: true,
      handler() {
        if (!this.isLoadingPage) {
          this.updateAllInfo()
        }
      }
    },
    locationGraphs: function() {
      if (!this.isLoadingPage) {
        this.updateAllInfo();
      }
    },
    datesGraph: function() {
      if (!this.isLoadingPage) {
        this.updateAllInfo();
      }
    }
  },

  methods: {
    toggleCollapse(concepto){
      if(this.collapses.includes(concepto)){
        this.collapses = this.collapses.filter(ff=>!ff.includes(concepto))
      } else {
        this.collapses.push(concepto)
      }
    },
    customOpenDateSelector() {
      this.isCustomOpen = !this.isCustomOpen;
    },
    getDate(date) {

      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    getCostoLote(etapa) {
      if (this.costos_lotes && this.lote) {
        const etapaSelect = this.costos_lotes.find(
          costo => costo.etapa == etapa
        );

        if (etapaSelect) {
          return etapaSelect.total;
        }
        return 0;
      }
      return 0;
    },
    getCostoLotePorcentaje(etapa, presupuesto) {
      let presupuestoUtilizadoEtapa = this.getCostoLote(etapa);

      if (presupuestoUtilizadoEtapa > 0 && presupuesto > 0) {
        return ((presupuestoUtilizadoEtapa / presupuesto) * 100).toFixed(2);
      }
      return 0;
    },
    toggleLote() {
      this.isLoteActive = !this.isLoteActive;
      this.color1 = this.isLoteActive ? "primary" : "secondary";
      this.color2 = this.isLoteActive ? "secondary" : "primary";
      this.isLoteActive ? (this.cultivo = null) : (this.lote = null);
    },
    updateAllInfo() {
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();

      this.isLoadingPage = true;

      this.itemsIngresos = [];
      this.itemsCostos = [];
      this.lotesPresupuesto = null;
      this.produccionEq = null;
      this.entregas = null;
      this.costos = null;

      // this.$store;
      // this.lote = null;
      // this.cultivo = null;
      let indicadores = [];
      if (this.cropGraphs) {
        indicadores = [
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "entregas_cultivo_embalaje",
              params: {
                fecha: this.datesGraph,
                cultivo: this.cropGraphs ? this.cropGraphs.value : "",
                cultivo_id: this.variedadGraphs ? this.variedadGraphs.value : '',
                embalaje: this.embalajeGraphs || [],
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "costos_concepto_categoria",
              params: {
                fecha: this.datesGraph,
                cultivo: this.cropGraphs ? this.cropGraphs.value : "",
                cultivo_id: this.variedadGraphs ? this.variedadGraphs.value : '',
                embalaje: this.embalajeGraphs || [],
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "lotes_presupuesto",
              params: {
                id: 1,
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "producciones_eq",
              params: {
                fecha: this.datesGraph,
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "entregas",
              params: {
                fecha: this.datesGraph,
                cultivo: this.cropGraphs ? this.cropGraphs.value : "",
                cultivo_id: this.variedadGraphs ? this.variedadGraphs.value : '',
                embalaje: this.embalajeGraphs || [],
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "costos",
              params: {
                fecha: this.datesGraph,
                cultivo: this.cropGraphs ? this.cropGraphs.value : "",
                cultivo_id: this.variedadGraphs ? this.variedadGraphs.value : '',
                embalaje: this.embalajeGraphs || [],
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          })
        ];
      } else {
        indicadores = [
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "entregas_cultivo_embalaje",
              params: {
                fecha: this.datesGraph,
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "costos_concepto_categoria",
              params: {
                fecha: this.datesGraph,
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "lotes_presupuesto",
              params: {
                id: 1,
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "producciones_eq",
              params: {
                fecha: this.datesGraph,
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "entregas",
              params: {
                fecha: this.datesGraph,
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          }),
          this.$store.dispatch("customIndicadoresHTTP", {
            body: {
              reporte: "costos",
              params: {
                fecha: this.datesGraph,
                ...this.locationGraphs?{ubicacion: this.locationGraphs.value}:{},
                ubicaciones: [this.ubicacionRaiz]
              }
            },
            cancelToken: this.cancelSource
          })
        ];
      }

      Promise.all(indicadores)
        .then(
          ([
            ingresosCultivos,
            costos,
            presupuestoLotes,
            produccionE,
            entregasRes,
            costosRes
            // costosDia
          ]) => {
            this.itemsIngresos = ingresosCultivos.data;
            this.itemsCostos = costos.data;
            this.lotesPresupuesto = presupuestoLotes.data;
            this.produccionEq = produccionE.data;
            this.entregas = entregasRes.data;
            this.costos = costosRes.data;

            this.isLoadingPage = false;
          }
        )
        .catch(err => {
          if (err !== "Stop") {
            this.isLoadingPage = false;
          }
        });
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Stop");
        // console.log("cancel request done");
      }
    },
    fetchCombos() {
      this.isLoadingPage = true;
      // // console.log(moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59"));
      // if (!this.ubicacionesRaiz.length) {
      const ubi = [
        this.$store.dispatch('customHTTP', {
          schema: 'configuracion',
          filter: {
            where: [{field: 'payload->parametro', value: 'cultivos', operator: '='}]
          }
        }),
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->pertenece_id",
                value: 0,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        }),
        this.$store.dispatch("customHTTP", { schema: "cultivos" }),
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->raiz_id",
                value: this.ubicacionRaiz,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      Promise.all(ubi)
        .then(([configuracion, ubicaciones, cultivos, ubicacionesAll]) => {
          // console.log(ubicaciones.data);
          this.ubicaciones = ubicaciones.data.map(ubi => {
            return { value: ubi.id, label: ubi.payload.nombre };
          });
          this.cultivos = configuracion.data[0].payload.valor.map((cultivo,) => {
            return {label: cultivo.nombre, value: cultivo.nombre, embalajes: cultivo.embalajes }
          })
          this.variedades = cultivos.data.map(cultivo => {
            return { value: cultivo.id, label: cultivo.payload.variedad, cultivo: cultivo.payload.nombre};
          }).filter(variedad => {
            return variedad.label != undefined
          });
          this.ubicaciones2 = ubicacionesAll.data.map(ubi => {
            return { value: ubi.id, label: ubi.payload.nombre };
          });
          // console.log(values);
          // this.ubicaciones = ubicaciones.data;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => {
          if (this.itemsIngresos.length || this.itemsCostos.length || this.lotesPresupuesto || this.produccionEq || this.entregas || this.costos) {
            this.isLoadingPage = false;
          }
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.txt-purple {
  color: #321fdb;
}
.txt-green {
  color: #2eb85c !important;
}
.txt-red {
  color: #e55353 !important;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.dropdown-sp {
  width: 400px;
}
.cursor-p {
  cursor: pointer;
}
.root-location {
  width: 180px;
  margin: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selector-input {
  width: 180px;
  margin-left: 0.5rem;
}
.selector-input-2 {
  width: 180px;
  margin: 0 0.5rem;
}
.root-location-input {
  width: 100%;
}
.margi-dates {
  margin: 0 0.5rem;
}
.sp-margin-b {
}
.sp-margin-ul {
}
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
/* .btn-header {
  max-width: 120px;
} */
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
@media (max-width: 700px) {
  .selector-input {
    width: 180px;
    margin-left: 0.5rem;
  }
  .selector-input-2 {
    width: 200px;
    margin: 0 0.5rem;
  }
  .margi-dates {
    margin: 0 0.4rem;
  }
}
@media (max-width: 620px) {
  .selector-input {
    width: 200px;
    margin-right: 0.4rem;
  }
  .selector-input-2 {
    width: 200px;
    margin: 0.4rem;
  }
}
@media (max-width: 580px) {
  .margi-dates {
    margin: 0 0.3rem;
  }
  .selector-input {
    margin-top: 0.4rem;
    margin-bottom: 0.2rem;
  }
}
@media (max-width: 450px) {
  .root-location {
    width: 120px;
    margin: 0 0.2rem;
  }
  .sp-margin-b {
    margin-left: 0.5rem !important;
  }
  .sp-margin-ul {
    margin-right: 0.5rem !important;
  }
}
@media (max-width: 360px) {
  .root-location {
    width: 100px;
    margin: 0 0.2rem;
  }
  .sp-font-size {
    font-size: 10px;
    font-weight: 400;
  }
  .sp-margin-b {
    margin-left: 0.1rem !important;
  }
  .sp-margin-ul {
    margin-right: 0.1rem !important;
  }
  .clave {
    font-size: 11px;
  }
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
/* .btn-header {
  max-width: 120px;
} */
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
